import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface AccessoryDrawerState {
    open: boolean
}

export const useAccessoryDrawerStore = create<AccessoryDrawerState>()(
    devtools(
        (set, get) => ({
            open: false,
        }),
        {
            name: 'AccessoryDrawerStore',
        },
    ),
)

export const getAccessoryDrawerState = () => useAccessoryDrawerStore.getState().open
export const setAccessoryDrawerState = (open: boolean) => useAccessoryDrawerStore.setState({ open })
export const closeAccessoryDrawer = () => setAccessoryDrawerState(false)
export const openAccessoryDrawer = () => setAccessoryDrawerState(true)
export const toggleAccessoryDrawerOpen = () => setAccessoryDrawerState(!getAccessoryDrawerState())

export const useAccessoryDrawerWidth = () => {
    const { open } = useAccessoryDrawerStore()
    const accessoryDrawerWidth = open ? 300 : 0
    return accessoryDrawerWidth
}
